import script from "./group_plan_page.vue?vue&type=script&setup=true&lang=js"
export * from "./group_plan_page.vue?vue&type=script&setup=true&lang=js"

import "./group_plan_page.vue?vue&type=style&index=0&id=0f571cad&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f571cad"]])

export default __exports__